import { render, staticRenderFns } from "./AccountsTree.vue?vue&type=template&id=a5424c46"
import script from "./AccountsTree.vue?vue&type=script&lang=js"
export * from "./AccountsTree.vue?vue&type=script&lang=js"
import style0 from "./AccountsTree.vue?vue&type=style&index=0&id=a5424c46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports